import { render, staticRenderFns } from "./YJXX.vue?vue&type=template&id=5959e6f1&"
import script from "./YJXX.vue?vue&type=script&lang=js&"
export * from "./YJXX.vue?vue&type=script&lang=js&"
import style0 from "./YJXX.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports